const ApplicationModalClass = function () {

    this.showModal  = function(element) {
        console.log('showModal '+element)
        let content = element.parentNode.querySelector('.modal-content')

        if(document.getElementById('general-modal')){
            document.getElementById('general-modal').remove()
        }

        let modal = document.createElement( 'div' )
        modal.setAttribute('id','general-modal')
        modal.innerHTML = "<div class='modal-close-background position-absolute width-100 height-100 top-0 left-0' ></div><div id='general-modal_inner' class='margin-0-auto background-white padding-md position-relative ' >"+content.innerHTML+"<div class='modal-close cursor-pointer' tabindex='0' aria-label='Close modal' >&times;</div></div>";
        document.body.appendChild(modal)
        document.body.classList.add('body')

        document.querySelector('#general-modal .modal-close').focus()



        document.querySelector('#general-modal .modal-close-background').onclick = function(e){
            applicationModal.closeModal()
        }

        document.querySelector('#general-modal .modal-close').onclick = function(e){
            applicationModal.closeModal()
        }
    }

    this.closeModal  = function() {
        console.log('closeModal')
        document.getElementById('general-modal').remove()
        document.body.classList.remove('in-modal')
    }
}

class ScrollerClass {

    constructor(el) {
        console.log('ScrollerClass')
        this.el = el

        this.currentPos = 1
        this.nodes = this.el.querySelectorAll('.GridRow__card')
        this.grid = this.el.querySelector('.GridRow__grid')
        this.train = this.el.querySelector('.GridRow__grid-train')
        this.pagers = this.el.querySelectorAll('.GridRow__controls-dots span')
        this.pagers2 = this.el.querySelectorAll('.GridRow__controls-thumbs span')
        this.initScroller()
        this.run()
        this.swipeDetect()
        this.el.classList.remove('no-opacity')
    }

    initScroller() {
        let self = this
        setInterval(function (){

            let slideWidth = 0
            if(self.grid.classList.contains('GridRow__grid-slideshow-testimonials')){
                //console.log('ScrollerClass',self.grid.clientWidth)
                slideWidth = self.grid.clientWidth > 749 ? self.grid.clientWidth : self.grid.clientWidth * 0.9
            }else{
                for (let i=0; i< self.nodes.length; i++) {
                    if(!self.nodes[i].classList.contains('GridRow__card-active')){
                        let rect = self.nodes[i].getBoundingClientRect()
                        let style = self.nodes[i].currentStyle || window.getComputedStyle(self.nodes[i])
                        slideWidth = rect.width+parseFloat(style.marginLeft)+parseFloat(style.marginRight)
                        break
                    }
                }
            }

            for(let i=0; i< self.nodes.length; i++) {
                if(self.grid.classList.contains('GridRow__grid-slideshow-testimonials')){
                    self.nodes[i].setAttribute('style','max-width:'+slideWidth+'px')
                }else{
                    if(self.nodes[i].querySelector('.GridRow__card-text').scrollHeight > self.nodes[i].querySelector('.GridRow__card-text').clientHeight){
                        self.nodes[i].querySelector('.GridRow__card-text').parentNode.classList.add('is-clamped')
                    }else{
                        self.nodes[i].querySelector('.GridRow__card-text').parentNode.classList.remove('is-clamped')
                    }
                }
            }

            let targetMargin = -(self.currentPos-1)*slideWidth
            let vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            if (!self.el.classList.contains('GridRow-controls-dots') && !self.grid.classList.contains('GridRow__grid-slideshow-testimonials')){
                if(vw < 600 ){
                    targetMargin = 0
                }
            }

            self.train.setAttribute('style','margin-left:'+targetMargin+'px')
            //console.log('ScrollerClass',self.currentPos,self.train.offsetWidth,slideWidth)


        },200)
    }


    unsetPagers() {
        for(let i=0; i< this.pagers.length; i++) {
            this.pagers[i].classList.remove('current-pager')
        }
        for(let i=0; i< this.pagers2.length; i++) {
            this.pagers2[i].classList.remove('current-pager')
        }
    }

    run() {
        for(let i=0; i< this.pagers.length; i++) {
            this.pagers[i].addEventListener('click',(event) => {
                this.currentPos = event.currentTarget.getAttribute('data-index')
                this.updatePos()
            })
        }
        for(let i=0; i< this.pagers2.length; i++) {
            this.pagers2[i].addEventListener('click',(event) => {
                this.currentPos = event.currentTarget.getAttribute('data-index')
                this.updatePos()
            })
        }

        let nodelist =  this.el.querySelectorAll('.GridRow__card-read-more')
        for(let i=0; i< nodelist.length; i++) {
            nodelist[i].addEventListener('click',(event) => {
                if(event.currentTarget.parentNode.classList.contains('unclamp')){
                    event.currentTarget.parentNode.classList.remove('unclamp')
                }else{
                    event.currentTarget.parentNode.classList.add('unclamp')
                }
            })
        }

        this.el.querySelector('.GridRow__controls-next').addEventListener('click',(event) => {
            this.next()
        })

        this.el.querySelector('.GridRow__controls-prev').addEventListener('click',(event) => {
            this.prev()
        })
    }


    prev() {
        console.log('prev: '+this.currentPos+" "+this.nodes.length)
        if(this.currentPos == 1){
            this.currentPos = this.nodes.length
        }else {
            this.currentPos--
        }
        this.updatePos()
    }

    next() {
        console.log('next: '+this.currentPos)
        if(this.currentPos == this.nodes.length){
            this.currentPos = 1
        }else {
            this.currentPos++
        }
        this.updatePos()
    }

    unsetReadMore() {
      let contentNodes = this.el.querySelectorAll('.GridRow__card-content-lower')
      for (let i=0; i< contentNodes.length; i++) {
        if (contentNodes[i].classList.contains('unclamp')) {
          contentNodes[i].classList.remove('unclamp')
        }
      }
    }

    updatePos() {
        for (let i=0; i< this.nodes.length; i++) {
            this.nodes[i].classList.remove('GridRow__card-active')
        }
        this.unsetReadMore()
        this.unsetPagers()
        this.el.querySelector('.GridRow__card-'+this.currentPos).classList.add('GridRow__card-active')
        let currentPager = this.el.querySelector('.GridRow__controls-dots span[data-index="'+this.currentPos+'"]')
        if(currentPager){
            currentPager.classList.add('current-pager')
        }
        let currentPager2 = this.el.querySelector('.GridRow__controls-thumbs span[data-index="'+this.currentPos+'"]')
        if(currentPager2){
            currentPager2.classList.add('current-pager')
        }
        console.log('updatePos')
    }

    swipeDetect() {

        let self = this
        this.el.addEventListener('touchstart', handleTouchStart, false)
        this.el.addEventListener('touchmove', handleTouchMove, false)

        let xDown = null
        let yDown = null

        function getTouches(evt) {
            return evt.touches ||             // browser API
                evt.originalEvent.touches; // jQuery
        }

        function handleTouchStart(evt) {
            console.log('handleTouchStart')
            const firstTouch = getTouches(evt)[0];
            xDown = firstTouch.clientX;
            yDown = firstTouch.clientY;
        }

        function handleTouchMove(evt) {
            if (!xDown || !yDown) {
                return;
            }

            let xUp = evt.touches[0].clientX;
            let yUp = evt.touches[0].clientY;

            let xDiff = xDown - xUp;
            let yDiff = yDown - yUp;

            if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
                if (xDiff > 0) {
                    /* left swipe */
                    self.next()
                } else {
                    /* right swipe */
                    self.prev()
                }
            } else {
                if (yDiff > 0) {
                    /* up swipe */
                } else {
                    /* down swipe */
                }
            }
            /* reset values */
            xDown = null;
            yDown = null;
        }
    }


}
const ApplicationJSClass = function () {


    document.addEventListener("DOMContentLoaded", function () {
        console.log('main document ready')
        applicationJS.initializePage()
        const lazyLoadInterval = setInterval(function(){
            applicationJS.deferredLoading()
        },300)
    })

    this.initializePage = function() {
        console.log('initializePage');

        let nodelist =  document.querySelectorAll('.GridRow-mode-horizontal-scroll-reviews, .SlideshowTestimonials')
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i]
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize')
                let scroller = new ScrollerClass(nodelist[i])
            }
        }
        nodelist =  document.querySelectorAll('.event-triggers__play-video')

        for (let i=0; i< nodelist.length; i++) {
            let element = nodelist[i]
            if(!element.classList.contains('did-initialize')){
                element.classList.add('did-initialize')

                element.onclick = function(e){
                    applicationJS.playVideo(element)
                }

                element.onkeyup = function(e){
                    if (e.key === "Enter") {
                        applicationJS.playVideo(element)
                    }
                }

            }else{
                console.log("already initialized "+element.getAttribute('id'))
            }
        }

        nodelist = document.querySelectorAll('.image-with-text__text_below_button, .multicolumn-list__headline-with-ratings .rte');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.innerHTML = el.innerHTML.replace('★★★★★','<span class="color-bright-blush" >★★★★★</span>')
                el.innerHTML = el.innerHTML.replace('★★★★☆','<span class="color-bright-blush" >★★★★☆</span>')
                el.classList.add('did-initialize')
            }
        }
        nodelist =  document.querySelectorAll('.event-triggers__product-discount-tag-details')
        for (let i=0; i< nodelist.length; i++) {
            let element = nodelist[i]
            if(!element.classList.contains('did-initialize')){
                element.classList.add('did-initialize')
                element.onclick = function(e){
                    applicationModal.showModal(e.currentTarget)
                }
            }
        }
        console.log('handlePreview');
        let hash = window.location.hash;
        if('#preview' == hash) {
            nodelist = document.querySelectorAll('.is-preview');
            for (let i=0; i< nodelist.length; i++) {
                let el = nodelist[i];
                if(!el.classList.contains('did-initialize')){
                    el.classList.remove('d-none')
                    el.classList.remove('is-preview')
                }
            }

        }

    }

    this.deferredLoading = function(){
        let nodelist = document.querySelectorAll('.appear-event, .lazy-load');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];

            let rect = el.getBoundingClientRect();
            let top_of_object = rect.top;
            let bottom_of_object = rect.bottom;
            let bottom_of_window = window.pageYOffset + window.innerHeight;
            //console.log( bottom_of_window,top_of_object);
            if( bottom_of_window > top_of_object ){
                el.classList.add('appear-event-scrolled-in-view');

                if(el.classList.contains('lazy-load') && !el.classList.contains('initialized-lazy-load')){
                    el.setAttribute('src',el.getAttribute('data-src'));
                    if(el.getAttribute('data-srcset')){
                        el.setAttribute('srcset',el.getAttribute('data-srcset'));
                    }
                    el.classList.add('initialized-lazy-load');
                }
            }
            if( bottom_of_window > bottom_of_object ){

            }
        }
    }

    this.playVideo  = function(element) {
        let id = 'Video-'+element.getAttribute('data-handle')
        console.log('playVideo '+id)
        let video = document.getElementById(id)

        if(document.getElementById('video-modal')){
            document.getElementById('video-modal').remove()
        }

        let modal = document.createElement( 'div' );
        modal.setAttribute('id','video-modal');
        modal.innerHTML = "<div class='modal-close-background position-absolute width-100 height-100 top-0 left-0' ></div><div id='video-modal_inner' class='margin-0-auto position-relative opacity-0' >"+video.innerHTML+"<div class='modal-close cursor-pointer' tabindex='0' aria-label='Close modal' >&times;</div></div>";
        document.body.appendChild(modal);
        document.body.classList.add('body');
        if(document.querySelector('#video-modal_inner p')){document.querySelector('#video-modal_inner p').remove()}
        if(document.querySelector('#video-modal_inner a')){document.querySelector('#video-modal_inner a').remove()}
        if(document.querySelector('#video-modal_inner iframe')){document.querySelector('#video-modal_inner iframe').setAttribute('autoplay','true')}
        document.querySelector('#video-modal .modal-close').focus()

        let width = document.querySelector('#video-modal_inner iframe').getAttribute('width')
        let height = document.querySelector('#video-modal_inner iframe').getAttribute('height')
        let dataRatio = width+'/'+height
        document.querySelector('#video-modal_inner').setAttribute('style','aspect-ratio:'+dataRatio);
        document.querySelector('#video-modal_inner').setAttribute('data-ratio',dataRatio);
        console.log(dataRatio);
        let timeout = setTimeout(function(){
                document.querySelector('#video-modal_inner').classList.add('opacity-1');
            },100
        );

        document.querySelector('#video-modal .modal-close-background').onclick = function(e){
            applicationJS.closeVideoModal()
        }

        document.querySelector('#video-modal .modal-close').onclick = function(e){
            applicationJS.closeVideoModal()
        }

    }

    this.closeVideoModal  = function() {
        console.log('closeVideoModal')
        document.getElementById('video-modal').remove();
        document.body.classList.remove('in-modal');

    }


}

const applicationJS = new ApplicationJSClass()
const applicationModal = new ApplicationModalClass()

document.addEventListener('shopify:inspector:activate', () => applicationJS.initializePage())
document.addEventListener('shopify:inspector:deactivate', () => applicationJS.initializePage())
document.addEventListener('shopify:section:load', () => applicationJS.initializePage())
document.addEventListener('shopify:section:unload', () => applicationJS.initializePage())
document.addEventListener('shopify:inspector:activate', () => applicationJS.initializePage())
document.addEventListener('shopify:inspector:deactivate', () => applicationJS.initializePage())
document.addEventListener('shopify:section:load', () => applicationJS.initializePage())
document.addEventListener('shopify:section:unload', () => applicationJS.initializePage())

